<template>
  <div
    :style="{ 'z-index': getPopupZindex }"
    :class="{ 'prompt-overlay': true, 'is-visible': isVisible }">
    <div class="prompt">
      <h2>{{ title }}</h2>

      <p
        v-if="additionalInfo"
        class="prompt-additional-info"
        :data-type="additionalInfoType">
        {{ additionalInfo }}
      </p>

      <input
        :type="inputType"
        :class="{ 'is-invalid': inputIsInvalid }"
        :min="isNumeric ? 0 : ''"
        @keyup="keyUp"
        v-model="value" />

      <btn
        @click.native="ok"
        type="popup-left">
        {{ okLabel }}
      </btn>
      <btn
        @click.native="cancel"
        type="popup-right">
        {{ cancelLabel }}
      </btn>
    </div>
  </div>
</template>

<script>
import PopupZindex from './../mixins/PopupZindex';

export default {
  name: 'prompt',
  mixins: [
    PopupZindex
  ],
  data () {
    return {
      inputIsInvalid: false,
      isVisible: false,
      title: '',
      additionalInfo: '',
      additionalInfoType: 'warning',
      isNumeric: false,
      okLabel: '',
      cancelLabel: '',
      value: '',
      okClick: false,
      cancelClick: false
    };
  },
  computed: {
    inputType () {
      if (this.isNumeric) {
        return 'number';
      }

      return 'text';
    }
  },
  mounted () {
    this.$bus.$on('prompt-display', this.show);
  },
  methods: {
    show (config) {
      this.isVisible = true;
      this.title = config.title || '';
      this.additionalInfo = config.additionalInfo || '';
      this.additionalInfoType = config.additionalInfoType || 'warning';
      this.value = config.defaultText || '';
      this.okLabel = config.okLabel || this.$t('common.ui.ok');
      this.cancelLabel = config.cancelLabel || this.$t('common.ui.cancel');
      this.okClick = config.okClick || false;
      this.cancelClick = config.cancelClick || false;
      this.isNumeric = config.isNumeric || false;

      this.increasePopupZindex();
    },
    ok () {
      if (
        this.value.trim() !== '' &&
        !this.isNumeric
      ) {
        if (this.okClick) {
          this.okClick(this.value);
        }

        this.hide();
      } else if (
        this.value.trim() !== '' &&
        this.isNumeric &&
        !isNaN(parseFloat(this.value)) &&
        parseFloat(this.value) >= 0.0
      ) {
        if (this.okClick) {
          this.okClick(this.value);
        }

        this.hide();
      } else {
        this.inputIsInvalid = true;
      }
    },
    cancel () {
      if (this.cancelClick) {
        this.cancelClick();
      }

      this.hide();
    },
    hide () {
      this.isVisible = false;
      this.removePopupZindex();
    },
    keyUp () {
      this.inputIsInvalid = false;
    }
  },
  beforeDestroy () {
    this.$bus.$off('prompt-display', this.show);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.prompt {
  background: $color-light;
  border-radius: $border-radius-small;
  box-shadow: 0 5px 5px rgba(0, 0, 0, .25);
  left: 50%;
  max-width: 94%;
  overflow: hidden;
  padding: 2rem 2rem 6rem 2rem;
  position: fixed;
  top: 50%;
  transform: translateX(-50%) translateY(-33.333333%);
  transition: transform .25s ease-out;
  width: 48rem;
  will-change: transform;

  &-overlay {
    background: rgba(0, 0, 0, .25);
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: opacity .25s ease-out;
    width: 100vw;
    will-change: opacity;

    &.is-visible {
      opacity: 1;
      pointer-events: auto;

      .prompt {
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }

  h2 {
    font-weight: 400;
    margin: 0 0 2rem 0;
  }

  .prompt-additional-info {
    border-radius: 3px;
    padding: .5rem 1rem;

    &[data-type="warning"] {
      background: $color-warning;
      color: $color-light;
    }
  }

  input {
    background: $color-bg-lightest;
    border: 1px solid $color-border;
    border-radius: $border-radius-small;
    font-size: 1.4rem;
    margin: .5rem 0 1rem 0;
    padding: 1rem;
    width: 100%;

    &::-webkit-input-placeholder {
      color: $color-text-lightest;
    }

    &::-moz-placeholder {
      color: $color-text-lightest;
    }

    &:-ms-input-placeholder {
      color: $color-text-lightest;
    }

    &:-moz-placeholder {
      color: $color-text-lightest;
    }

    &.is-invalid {
      border-color: $color-danger;
      color: $color-danger;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Prompt.vue